import React from "react";
import {useDropzone} from "react-dropzone";
import imageCompression from "browser-image-compression";
import {toast} from "react-toastify";
import {instance} from "../axios";

export default function ImageUploader({onUploaded}) {

  async function resizeImage(file){

    const options = {
      maxWidthOrHeight:1400,
      useWebWorker:true
    };

    return await imageCompression(file,options);
  }

  async function uploadImage(file){

    const formData = new FormData();
    formData.append("file",file);

    const res = await instance.post(
      "/upload_image",
      formData,
      {headers:{"Content-Type":"multipart/form-data"}}
    );

    return res.data;
  }

  const onDrop = async (acceptedFiles)=>{

    for(const file of acceptedFiles){

      try{

        const resized = await resizeImage(file);

        const result = await uploadImage(resized);

        onUploaded({
          id:result.id,
          url:result.url
        });

      }catch(e){

        toast("Image upload failed",{type:"error"});

      }

    }

  };

  const {getRootProps,getInputProps} = useDropzone({onDrop});

  return (

    <div
      {...getRootProps()}
      className="border p-4 text-center mb-3"
      style={{cursor:"pointer"}}
    >

      <input {...getInputProps()} />

      Drag images here or click to upload

    </div>

  );

}